module.exports = __webpack_public_path__ + "static/media/Articles 7.a3ec1d19.svg";